// The vendors this person added in this session (release 3.3, the mentor's
// second point). Adding a vendor lands on the register, not inside the vendor
// and not on the send screen, with the new vendor pinned at the top and marked
// New, whatever the sort: the register sorts by risk band, and a vendor with
// no band yet would otherwise sort to the bottom of the list.
//
// Kept in sessionStorage, so the mark lasts while the tab is open and is gone
// the next time the person signs in. A browser that refuses storage keeps
// only what the address carries (?added=).

const KEY = 'tprm.vendors.justAdded'

function read(): string[] {
  try {
    const raw = sessionStorage.getItem(KEY)
    const ids = raw ? (JSON.parse(raw) as unknown) : []
    return Array.isArray(ids) ? ids.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function rememberAdded(id: string): void {
  const ids = read()
  if (ids.includes(id)) return
  try {
    sessionStorage.setItem(KEY, JSON.stringify([...ids, id]))
  } catch {
    // The address still carries this one.
  }
}

// Every vendor added in this session, and those the address names.
export function justAdded(fromAddress: string[] = []): Set<string> {
  return new Set([...read(), ...fromAddress])
}

// The ids in ?added=, in the order they were added.
export function addedInAddress(hash: string = window.location.hash): string[] {
  const q = hash.split('?')[1] ?? ''
  return (new URLSearchParams(q).get('added') ?? '')
    .split(',')
    .map((x) => x.trim())
    .filter((x) => /^[0-9a-f-]{36}$/i.test(x))
}

// Where the person lands after adding: the register, with this run's vendors
// in the address so the confirmation can name them.
export function registerAfterAdding(ids: string[]): string {
  return '#/vendors?added=' + ids.join(',')
}
